import React from "react";
import {ValueValidator} from "../Validator";
import {RootState} from "../../../../app/store";
import {OnValidChangeHandler} from "../component/ValidationComponent";
import {SelectDropdown, SelectOption} from "../../select/SelectDropdown";
import {DependantValidationComponent} from "./DependantValidationComponent";

interface Props<PROPERTY, OBJECT> {
    validator: ValueValidator<PROPERTY>
    selector: (state: RootState) => PROPERTY | undefined;
    anchorValueSelector: (state: RootState) => any | undefined
    disabled?: boolean
    fieldName: keyof OBJECT;
    onChange: (value: PROPERTY) => any,
    updateValidationStatus: OnValidChangeHandler<OBJECT>,
    label: string;
    options: SelectOption<PROPERTY>[]
    getMessage: (f: string) => string
}

export const DependantValidatedSelectField = <PROPERTY, OBJECT>({
                                                                    validator,
                                                                    selector,
                                                                    fieldName,
                                                                    onChange,
                                                                    updateValidationStatus,
                                                                    anchorValueSelector,
                                                                    disabled,
                                                                    label,
                                                                    options,
                                                                    getMessage,
                                                                }: Props<PROPERTY, OBJECT>) => {
    return <DependantValidationComponent<PROPERTY, OBJECT>
        anchorValueSelector={anchorValueSelector}
        disabled={disabled}
        onChange={onChange}
        updateValidationStatus={updateValidationStatus}
        fieldName={fieldName}
        required={true}
        selector={selector}
        validator={validator}
        label={label}
        child={(label, value, onChange, required) =>
            <SelectDropdown<PROPERTY>
                title={label}
                disabled={disabled}
                isRequired={required}
                value={value}
                handleChange={onChange}
                options={options}
                errorMessage={getMessage(fieldName as string)}
            />
        }
    />
}
